import React, { useState, useRef } from 'react';
import style from '../../Styles/Order/Pedido.module.css';
import Customer from '../Customer/Customer';
import OrderSummary from '../Order/OrderSummary.jsx';
import Enum  from '../../Common/Enum/Enum';
import ModalMessage from '../../Components/Html/ModalMessage';
import ApiCaller from '../../Api/ApiCaller'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { clearOrder } from '../../Global/OrderSlice';
import { removeOrderItem } from '../../Global/OrderSlice';
import { useDispatch } from 'react-redux';



const Pedido = () => {

  const centauri = useSelector((state) => state.auth.centauri);
  const [showModal, setShowModal] = useState(false);
  const [showPedido, setShowPedido] = useState(true);
  const [showCustomer, setShowCustomer] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderNumber, setOrderNumber] = useState(false);
  

  const customerRef = useRef();
  const orderItems = useSelector((state) => state.orderStorage.orderItems);
  const dispatch = useDispatch();
    
  const userId = localStorage.getItem('userId') || 1; 
  
  const cleanOrderItems = () => {
    dispatch(clearOrder());
  };
  
  const handleCancelOrder = () => {
    setShowModal(false);
  };

  const calculateGrandTotal = () => {
    if (!orderItems || orderItems.length === 0) return 0;
    return orderItems.reduce((total, item) => {
      return total + (item.quantity * item.price);
    }, 0);
  };

  const grandTotal = calculateGrandTotal();

  const handleContinue = () => {
    if (showPedido) {
      setShowPedido(false);
      setShowCustomer(true);
    } else if (showCustomer) {
      setShowPedido(true);
      setShowCustomer(false);
    }
  };
  
  const buildOrderDetail = () => {        
    return orderItems.map(item => ({
      idproduct: item.idproductcombo || item.id, 
      quantity: item.quantity,
      comments: item.notesaux || "" 
    }));
  };
 
  const handleConfirmOrder = async () => {
    
    if (!customerRef.current.validateFields()) {
      return;
    }
    const customerData = customerRef.current.getCustomerData();

    const pedidoObject = {
      iduser: "",
      addressdescription:  customerData.street + ' '+customerData.avenue + ' '+customerData.zone +" "+
                           customerData.departamento+","+customerData.municipio+' Referencias :' +customerData.addressDescription,
      comments: customerData.comments,
      discountpercentage: 0.0,
      firstName: customerData.firstName,
      secondName: "", 
      lastName: customerData.lastName,
      nit: customerData.nit,
      idDepartamento: customerData.idDepartamento,
      idMunicipio: customerData.idMunicipio,
      zone : customerData.idZone,
      avenue : customerData.idAvenue,
      street : customerData.idStreet,
      telephoneNumber1: customerData.telephoneNumber1,
      telephoneNUmber2: customerData.telephoneNumber2, 
      email: customerData.email,
      idPaymentMethod : customerData.idPaymentMethod,
      orderdetail: buildOrderDetail()
    }; 

    setIsSubmitting(true);    
    try {
      
      setShowModal(false);
      const response = await ApiCaller(process.env.REACT_APP_API_POST, process.env.REACT_APP_API_POST_PEDIDO, 
          pedidoObject,{            
            /*Authorization: centauri ? `Bearer ${centauri}` : ''*/
            Authorization: ''                              
          }
      );
             
      if (response && response.status === Enum.APIRESPONSEOK || response.status === Enum.APIRESPONSEREQUESTOK) {
          setOrderNumber(response.data.responseCode);                           
          dispatch(clearOrder());        
          setShowPedido(true);
          setShowCustomer(false);
      } else {
          alert(`Error al confirmar el pedido: ${response?.data?.message || 'Error desconocido'}`);
      }
    } catch (error) {
          console.error('Error al enviar el pedido:', error);
          const errorMessage = error.response?.data?.message || error.message || 'Error de conexión al confirmar el pedido'+ error;
          alert(errorMessage);
    } finally {
          setIsSubmitting(false);
    }
  };

  const buttonText = showPedido ? "Continuar" : "Volver a pedido";

  return (
    <div className={style.pedido}>
      {showPedido && (
        <div className={style.PedidoSection}>
          <div className={style.headerPedido}>
            <h2>Tu orden:</h2>
          </div>                
          <div className={style.mainBox}>
            <div className={style.bodyPedido}>
              {orderItems && orderItems.length > 0 ? (
                <ul>
                  {orderItems.map((item, index) => (
                    <li key={item.timestamp || index} style={{ marginBottom: '10px' }}>
                      <div className={style.contentList}>
                        <div className={style.imageblock} style={{ background: `url(${item.imagePath}) no-repeat center/cover` }}>
                        </div>
                        <div className={style.orderDescription}>
                          <div className={style.itemName}>
                            <strong>{item.name}</strong>
                          </div>
                          <div className={style.itemName}>                                            
                            <strong>Ingredientes:</strong>
                            {item.ingredients && Object.values(item.ingredients)
                              .filter(ing => ing.selected && ing.isbeverage===0)
                              .map(ing => ing.name)
                              .join(', ')}
                          </div>
                          <div className={style.itemName}> 
                            <strong>Bebida:</strong>
                            {item.ingredients && Object.values(item.ingredients)
                              .filter(ing => ing.selected && ing.isbeverage)
                              .map(ing => ing.name)
                              .join(', ')}
                          </div>
                          <div className={style.itemName}>                                                
                            {item.notes && <strong>Notas:</strong>}
                            {item.notes}
                          </div>
                        </div>
                        <div className={style.numberDetails}>                              
                          <div className={style.itemPrice}>
                            Q.{item.price}
                          </div>
                          <div className={style.itemQuantity}>
                            {item.quantity}
                          </div>
                          <div className={style.lineTotal} translate="no">
                            <strong>Q.{item.quantity * item.price}</strong>
                          </div>
                          <div className={style.removeItem}>
                            <Button className={`${style.buttonEliminar} btn btn-danger`} onClick={() => dispatch(removeOrderItem(item.timestamp))}>  
                              <FontAwesomeIcon icon={faTrashCan} className={style.iconEliminar} />
                            </Button>
                          </div> 
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div><p className={style.orderNumber}>{!orderNumber ? "Orden vacia" : "Orden # : " + orderNumber}</p>
                  {orderNumber && (
                    <div>
                        <OrderSummary idOrderParam = {orderNumber}/>   
                    </div> 
                  )}
                </div>                
              )}
            </div>                
          </div>
        </div>
      )}

      {showCustomer && (
        <div className={style.CustomerSection}>
          <Customer ref={customerRef} />
        </div>
      )}

      <div className={style.pedidoFooter}>
        <div className={style.grandTotal}>
          <strong>Total: Q.{grandTotal.toFixed(2)}</strong>
        </div>
        <div>
          <Button 
            className={!showCustomer && `${style.buttonAgregar} btn btn-success`} 
            onClick={handleContinue}
            disabled={isSubmitting}
          >
            {buttonText}
          </Button>
        </div>
        <div>
          {showCustomer && (
            <Button className={`${style.buttonConfirmar} btn btn-success`} onClick = {() => setShowModal(true)} disabled={isSubmitting}>
              {isSubmitting ? 'Enviando...' : 'Confirmar pedido'}
            </Button>
          )}
        </div>
      </div> 

      {<ModalMessage 
          show={showModal} 
          onConfirm={handleConfirmOrder} 
          onCancel={handleCancelOrder} 
          menuItemName={"Crear orden"} 
          quantity={grandTotal.toFixed(2)}
          typeOfMessage= {Enum.CONFIRMORDEN}
      />}

    </div>
  );
};

export default Pedido;